'use client';

import React from 'react';
import { HeaderNavMenu, WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { ShareButton } from 'ui-components/navigations/HeaderButtons';
import { SantaRitto2024 } from 'app-components/promotions/SantaRitto2024';
import { SnowEffect } from 'app-components/promotions/SnowEffect';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';

interface PromotionPageProps {
  isApp?: boolean;
}
export const PromotionPage = ({ isApp }: PromotionPageProps) => {
  useInAppHeader({
    screen: WebViewScreen.EventDetail,
    title: '산타 리토의 선물 대작전!',
    rightMenuList: [HeaderNavMenu.Share],
  });
  useInAppStatusBar(WebViewScreen.EventDetail);

  const title = '산타 리토의 선물 대작전';
  const text = '다함께 전구를 모으면 전원 최대 1,500P!';
  const url = 'https://www.diritto.co.kr/promotions/2024-santa-ritto';

  return (
    <MutableHeaderLayout
      title="산타 리토의 선물 대작전!"
      isApp={isApp}
      rightButtons={[
        <ShareButton
          key="share"
          params={{
            url,
            title,
            text,
          }}
        />,
      ]}
      noBottomPadding>
      <SantaRitto2024 />
      <SnowEffect className="fixed top-0 left-0 w-full h-screen overflow-hidden pointer-events-none" />
    </MutableHeaderLayout>
  );
};
